import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'binary-image-types',
    pluginName: 'IMPORT_EXPORT',
    entityName: 'BINARY_IMAGE_TYPE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true
});

// Fetch binary Image action creators
export const fetchBinaryImageTypeInit = () => {
    return crudActions.fetchInit();
};
export const fetchBinaryImageTypeStart = () => {
    return crudActions.fetchStart();
};
export const fetchBinaryImageTypeSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchBinaryImageTypeFail = () => {
    return crudActions.fetchFail();
};
export const fetchBinaryImageTypeCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchBinaryImageTypeStart());
        try {
            let countRes = await rest.post("binary-image-types/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchBinaryImageTypeSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchBinaryImageTypeFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch  binary image type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchBinaryImageTypeFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch  binary image type."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchBinaryImageType = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchBinaryImageTypeStart());
        try {
            let listRes = await rest.post("binary-image-types/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchBinaryImageTypeSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchBinaryImageTypeFail());
            return []

        } catch (error) {
            dispatch(fetchBinaryImageTypeFail());
            return []

        }
    }
}

// Load binary Image action creators
export const loadBinaryImageTypeInit = () => {
    return crudActions.loadInit();
};
export const loadBinaryImageTypeStart = () => {
    return crudActions.loadStart();
};
export const loadBinaryImageTypeSuccess = loadedBinaryImageType => {
    return crudActions.loadSuccess(loadedBinaryImageType);
};
export const loadBinaryImageTypeFail = error => {
    return crudActions.loadFail(error);
};
export const loadBinaryImageType = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create binary Image  action creators
export const createBinaryImageTypeInit = () => {
    return crudActions.createInit();
};
export const createBinaryImageTypeStart = () => {
    return crudActions.createStart();
};
export const createBinaryImageTypeSuccess = createdBinaryImageType => {
    return crudActions.createSuccess(createdBinaryImageType);
};
export const createBinaryImageTypeFail = error => {
    return crudActions.createFail(error);
};
export const createBinaryImageType = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createBinaryImageTypeStart());
        try {
            let res = await rest.post('/binary-image-types/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createBinaryImageTypeSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created binary image type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createBinaryImageTypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create binary image type."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create binary image type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createBinaryImageTypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit binary Image  action creators
export const editBinaryImageTypeInit = () => {
    return crudActions.editInit();
};
export const editBinaryImageTypeStart = () => {
    return crudActions.editStart();
};
export const editBinaryImageTypeSuccess = editedBinaryImageType => {
    return crudActions.editSuccess(editedBinaryImageType);
};
export const editBinaryImageTypeFail = error => {
    return crudActions.editFail(error);
};
export const editBinaryImageType = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editBinaryImageTypeStart());
        try {
            let res = await rest.post('/binary-image-types/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editBinaryImageTypeSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated binary image type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editBinaryImageTypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit binary image type."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit binary image type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editBinaryImageTypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Bulk delete binary Image action creators
export const bulkDeleteBinaryImageTypesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteBinaryImageTypesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteBinaryImageTypesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteBinaryImageTypesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteBinaryImageTypes = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteBinaryImageTypesStart());
        try {
            let res = await rest.post('/binary-image-types/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteBinaryImageTypesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted binary image types.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteBinaryImageTypesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete binary image types."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete binary image types."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteBinaryImageTypesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Delete binary Image  action creators
export const deleteBinaryImageTypeInit = () => {
    return crudActions.deleteInit();
};
export const deleteBinaryImageTypeStart = () => {
    return crudActions.deleteStart();
};
export const deleteBinaryImageTypeSuccess = deletedBinaryImageType => {
    return crudActions.deleteSuccess(deletedBinaryImageType);
};
export const deleteBinaryImageTypeFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteBinaryImageType = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};